import { escapeHtml } from '../inventoree/format'
import { lastActivityHtml } from '../inventoree/columns'
import { durationString } from '../easeedesk/format'
import type { TableColumn } from '../ui/DataTable'

/** `SaveneergeeDevicesModel` si `SaveenergeeEventsModel` din public/js/saveenergee.js. */
export type Column = TableColumn & { name?: string }

const DASH = '<i class="fas fa-minus font-10"></i>'

function textOrDash(value: unknown): string {
  return value ? escapeHtml(value) : DASH
}

function secondsOrDash(value: unknown): string {
  const n = Number(value)
  return n > 0 ? durationString(n) : DASH
}

function nameCell(r: Record<string, unknown>): string {
  return `<p>${escapeHtml(r.Denumire)}</p>` + (Number(r.ownerId) > 0
    ? `<span class="color-light-grey"><i class="fa fa-user"></i> ${escapeHtml(r.Prenume)} ${escapeHtml(r.Nume)}</span>`
    : '<span class="color-red"><i class="fa fa-user"></i> Unassigned</span>')
}

function typeCell(r: Record<string, unknown>): string {
  return `<center style="cursor:default" data-toggle="tooltip" data-placement="top" title="${escapeHtml(r.device_type ?? '')}">${r.device_icon}</center>`
}

/** Felul activitatii din `it_saveenergee_device_activity.activity_type`. */
export function activityLabel(type: unknown): string {
  switch (String(type)) {
    case '1': return '<label class="label label-info">Online</label>'
    case '2': return '<label class="label label-success">Hibernate</label>'
    case '3': return '<label class="label label-warning">Monitor sleep</label>'
    case '4': return '<label class="label label-danger">Shutdown</label>'
    default: return escapeHtml(type ?? '')
  }
}

export function deviceColumns(currency: string): Column[] {
  return [
    { index: 0, title: '', orderable: false, visible: true, width: 50, html: (r) => `<center class="show_details color-dark-grey pointer font-16" data-id="${r.ID}"><i class="fas fa-plus-circle"></i></center>` },
    { index: 1, title: 'Type', name: 'Tip', orderable: true, visible: true, width: 100, html: typeCell },
    { index: 2, title: 'Device name', name: 'Denumire', orderable: true, visible: true, html: nameCell },
    { index: 3, title: 'Last User Logged On', name: 'UserLogat', orderable: true, visible: true, html: (r) => textOrDash(r.UserLogat) },
    { index: 4, title: 'Office', name: 'office', orderable: true, visible: true, html: (r) => textOrDash(r.office) },
    { index: 5, title: 'Group', name: 'DeviceGroup', orderable: true, visible: true, html: (r) => textOrDash(r.DeviceGroup) },
    { index: 6, title: 'Last activity', name: 'DataAccesareDM', orderable: true, visible: true, html: (r) => lastActivityHtml(r.DataAccesareDM) },
    { index: 7, title: 'Running time', name: 'active_time', orderable: true, visible: true, html: (r) => secondsOrDash(r.active_time) },
    { index: 8, title: 'Manual Hibernate', name: 'user_hibernate', orderable: true, visible: true, html: (r) => secondsOrDash(r.user_hibernate) },
    { index: 9, title: 'Auto Hibernate', name: 'auto_hibernate', orderable: true, visible: true, html: (r) => secondsOrDash(r.auto_hibernate) },
    { index: 10, title: 'Monitor Sleep', name: 'monitor_sleep_time', orderable: true, visible: true, html: (r) => secondsOrDash(r.monitor_sleep_time) },
    { index: 11, title: 'Shut Down', name: 'shutdown_time', orderable: true, visible: true, html: (r) => secondsOrDash(r.shutdown_time) },
    { index: 12, title: 'Auto Energy Save', name: 'autoSaved', orderable: true, visible: true, html: (r) => (Number(r.autoSaved) > 0 ? `${r.autoSaved}kW` : DASH) },
    { index: 13, title: 'Saved Energy Value', name: 'autoSavedMoney', orderable: true, visible: true, html: (r) => (Number(r.autoSavedMoney) > 0 ? `${r.autoSavedMoney} ${escapeHtml(currency)}` : DASH) },
    {
      index: 14, title: 'Actions', name: 'ID', orderable: false, visible: true, width: 90,
      html: (r) => `<div class="btn-group"><button type="button" class="btn btn-sm btn-default dropdown-toggle" data-toggle="dropdown"><i class="fas fa-cog"></i> <span class="caret"></span></button>`
        + `<ul class="dropdown-menu dropdown-menu-right"><li><a href="#" class="goHibernate" data-id="${r.ID}"><i class="fas fa-moon"></i> Hibernate</a></li>`
        + `<li><a href="#" class="goShutdown" data-id="${r.ID}"><i class="fas fa-power-off"></i> Shut down</a></li></ul></div>`,
    },
  ]
}

export function eventColumns(): Column[] {
  return [
    { index: 0, title: 'Type', name: 'Tip', orderable: true, visible: true, width: 100, html: typeCell },
    { index: 1, title: 'Device name', name: 'Denumire', orderable: true, visible: true, html: nameCell },
    { index: 2, title: 'Last User Logged On', name: 'UserLogat', orderable: true, visible: true, html: (r) => textOrDash(r.UserLogat) },
    { index: 3, title: 'Office', name: 'office', orderable: true, visible: true, html: (r) => textOrDash(r.office) },
    { index: 4, title: 'Group', name: 'DeviceGroup', orderable: true, visible: true, html: (r) => textOrDash(r.DeviceGroup) },
    { index: 5, title: 'Activity', name: 'activity_type', orderable: true, visible: true, html: (r) => activityLabel(r.activity_type) },
    { index: 6, title: 'Start', name: 'start_date', orderable: true, visible: true, html: (r) => textOrDash(r.start_date) },
    { index: 7, title: 'Finish', name: 'end_date', orderable: true, visible: true, html: (r) => textOrDash(r.end_date) },
  ]
}
